export const insightTypes = {
    FETCH_TAB1_REQUEST: "INSIGHT_TAB1_FETCH_REQUEST",
    FETCH_TAB1_SUCCESS: "INSIGHT_TAB1_FETCH_SUCCESS",
    FETCH_TAB1_FAILURE: "INSIGHT_TAB1_FETCH_FAILURE",
    UPDATE_TAB2_FILTERS: "INSIGHT_TAB2_UPDATE_FILTERS",
    FETCH_TAB2_REQUEST: "INSIGHT_TAB2_FETCH_REQUEST",
    FETCH_TAB2_SUCCESS: "INSIGHT_TAB2_FETCH_SUCCESS",
    FETCH_TAB2_FAILURE: "INSIGHT_TAB2_FETCH_FAILURE",
};

export const fetchTab1Request = () => ({
    type: insightTypes.FETCH_TAB1_REQUEST
});

export const fetchTab1Success = (resp) => ({
    type: insightTypes.FETCH_TAB1_SUCCESS,
    payload: resp
});

export const fetchTab1Failure = (error) => ({
    type: insightTypes.FETCH_TAB1_FAILURE,
    payload: error
});

export const fetchTab2Request = (filters) => ({
    type: insightTypes.FETCH_TAB2_REQUEST,
    payload: filters
});

export const fetchTab2Success = (resp) => ({
    type: insightTypes.FETCH_TAB2_SUCCESS,
    payload: resp
});

export const fetchTab2Failure = (error) => ({
    type: insightTypes.FETCH_TAB2_FAILURE,
    payload: error
});

export const updateTab2filters = (filters) => ({
    type: insightTypes.UPDATE_TAB2_FILTERS,
    payload: filters
});